<template>
  <div>
    <child-dynamic-element
        v-for="element in elements"
        :element="{ conditionalValue: staticValue, ...element }"
        :key="element.identifier"
        :formName="formName"
    />
  </div>
</template>

<script>
import {DynamicElement} from "formvue-json";

export default {
  name: "StaticCondition",
  components: {
    "child-dynamic-element": DynamicElement,
  },
  props: {
    properties: {
      type: Object | Array,
      required: true,
    },
    elements: {
      type: Array,
    },
    formName: {
      type: String,
      required: true,
    },
  },
  computed: {
    staticValue() {
      return this.properties ? this.properties['staticValue'] : null;
    }
  }
};
</script>
